module.exports = __webpack_public_path__ + "img/af7a700.png";